<template>
  <v-card :max-width="maxWidth">
    <div class="primary pa-2" v-if="titleItem !== ''">
      <p class="white--text text-h6 font-weight-light pa-0 ma-0">
        {{ titleItem }}
      </p>
    </div>
    <v-card-title style="display: flex; justify-content: center" class="mb-4">
      <p class="small my-auto">{{ mode }}</p>
    </v-card-title>
    <v-form
      @submit.prevent="submitForm"
      class="mx-4"
      ref="form"
      v-model="valid"
    >
      <v-alert
        dense
        v-if="error"
        color="red"
        elevation="5"
        outlined
        text
        type="error"
        align="center"
        class="mr-1 ml-1"
      >
        {{ alertValidate }}
      </v-alert>
      <DateWithCheck
        v-if="showDate"
        :showCheck="showCheck"
        :showDateFrom="showDateFrom"
        :showDateTo="showDateTo"
        class="mb-4"
      />
      <v-text-field
        v-for="(input, i) in inputsForm"
        :key="'input_' + i + input.name"
        :name="input.name"
        v-model="input.data"
        :type="input.type"
        :label="input.label"
        :rules="input.rules"
        outlined
        dense
        class="ma-0"
        :readonly="input.readonly"
        :disabled="input.disabled"
      />
      <div
        v-for="(slider, i) in inputSlider"
        :key="'slider_' + i + slider.name"
        v-show="show"
        class="slider-container mb-6"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <p class="ml-5" style="color: rgb(100, 98, 98)" v-on="on">
              {{ slider.label }}
            </p>
          </template>
          <span>{{ slider.tooltip }}</span>
        </v-tooltip>
        <v-slider
          class="mx-10"
          :value="slider.data"
          @change="handleSliderChange(slider)"
          v-model="slider.data"
          :thumb-size="33"
          thumb-label="always"
          hide-details
          track-color="primary"
          :name="slider.name"
          track-mark-color="primary"
          :max="slider.max"
          :min="slider.min"
          step="60"
        >
          <template v-slot:thumb-label="{ value }">
            {{ formatHours(value) }}
          </template>
        </v-slider>
        <div class="d-flex justify-space-between my-n7 mx-2">
          <p style="color: rgb(112, 111, 111)">-12</p>
          <p style="color: rgb(112, 111, 111)">+12</p>
        </div>
      </div>
      <div
        v-for="(checkbox, index) in checkboxes"
        :key="'checkbox_' + index + checkbox.name"
        class="d-block"
      >
        <v-checkbox
          v-model="checkbox.data"
          :label="checkbox.label"
          :name="checkbox.name"
          :value="checkbox.data"
          class="ma-0"
          @change="handleCheckboxChange(checkbox)"
        />
      </div>
      <div v-for="(input, i) in inputsHours" :key="'input_' + i + input.name">
        <v-text-field
          v-if="input.show"
          :name="input.name"
          v-model="input.data"
          :readonly="input.readonly"
          maxlength="5"
          :label="input.label"
          :rules="input.rules"
          @input="formatedHour(input)"
          outlined
          dense
        />
      </div>
      <div
        v-for="(select, name) in selects"
        :key="'input_' + name + select.name"
        v-show="show"
      >
        <v-autocomplete
          :disabled="disableSelect"
          :name="select.name"
          :items="select.items"
          :item-text="select.itemsText"
          :item-value="select.itemsValue"
          v-model="select.data"
          :label="select.label"
          :rules="select.rules"
          outlined
          @change="handleChange(select)"
          :multiple="multiple"
          :readonly="select.readonly"
          dense
          :no-data-text="$tc('commons.noDataAvailable')"
        />
      </div>
      <div
        v-if="uploadFiles"
        class="drop-zone mb-4"
        :class="{ 'drop-active': isDragging }"
        @dragover.prevent="isDragging = true"
        @dragleave="isDragging = false"
        @drop.prevent="handleDrop"
      >
        <v-file-input
          accept=".pdf,image/*"
          v-model="certificateFile"
          label="certificado de ausencia"
          outlined
          dense
          append-icon="mdi-paperclip"
          :prepend-icon="null"
          hide-details
          class="mb-3"
        />

        <div class="text-caption text-center grey--text">
          Arrastrá el archivo acá o hacé click arriba
        </div>
      </div>
      <div class="d-flex justify-space-between pb-4">
        <v-btn class="bt-exit" @click="cancel">{{
          $tc("editRegistrations.cancel")
        }}</v-btn>
        <v-btn type="submit" class="bt-acept ml-3">
          {{ $tc("editRegistrations.acept") }}</v-btn
        >
      </div>
    </v-form>
  </v-card>
</template>

<script>
import DateWithCheck from "../Complement/DateWithCheck.vue";
import Vue from "vue";

export default {
  components: { DateWithCheck, Date },
  props: {
    items: {
      type: Array,
    },
    maxWidth: String,
    mode: String,
    itemsSelect: Array,
    disableSelect: {
      type: Boolean,
      default: false,
    },
    show: {
      type: Boolean,
      default: false,
    },
    itemsSlider: Array,
    showDate: Boolean,
    showCheck: Boolean,
    showDateFrom: {
      type: Boolean,
      default: true,
    },
    showDateTo: {
      type: Boolean,
      default: true,
    },
    multiple: Boolean,
    itemsCheckbox: Array,
    showCheck: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    itemsHours: Array,
    titleItem: {
      type: String,
      default: "",
    },
    uploadFiles: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputsForm: [],
      valid: true,
      error: false,
      alertValidate: "",
      selects: [],
      inputSlider: [],
      checkboxes: [],
      inputsHours: [],
      isChange: false,
      certificateFile: null,
      isDragging: false,
    };
  },
  mounted() {
    this.checkboxes = Vue.observable(this.itemsCheckbox);
    this.inputsForm = Vue.observable(this.items);
    this.selects = Vue.observable(this.itemsSelect);
    this.inputSlider = Vue.observable(this.itemsSlider);
    this.inputsHours = Vue.observable(this.itemsHours);
  },
  methods: {
    handleDrop(e) {
      this.isDragging = false;
      const files = e.dataTransfer.files;
      if (files.length) {
        this.certificateFile = files[0];
      }
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    submitForm(e) {
      if (e) {
        e.preventDefault();
      }
      const form = this.$refs.form.$el;
      this.validation(form);
    },
    async handleSubmit(form) {
      const formData = new FormData(form);
      const itemsComplete = {};

      for (let [name, value] of formData) {
        itemsComplete[name] = value;
      }

      if (this.certificateFile !== null) {
        itemsComplete["certificateFile"] = await this.toBase64(
          this.certificateFile,
        );
      }

      this.$refs.form.resetValidation();
      this.certificateFile = null;

      this.$emit("save", itemsComplete);
    },
    cancel() {
      this.$refs.form.resetValidation();
      this.certificateFile = null;
      this.$emit("cancel", false);
    },
    validation(form) {
      let valid = this.$refs.form.validate();
      if (valid) {
        this.handleSubmit(form);
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },
    handleSliderChange(slider) {
      let item = {};
      item[slider.name] = slider.data;

      this.$emit("changeSlider", item);
    },

    formatHours(value) {
      const hour = Math.floor(value / 60);
      const minutes = value % 60;
      const sign = hour >= 0 ? "" : "-";
      const formattedHour = Math.abs(hour).toString().padStart(2, "0");
      const formattedMinutes = minutes.toString().padStart(2, "0");

      return `${sign}${formattedHour}:${formattedMinutes}`;
    },
    handleChange(selectedSelect) {
      this.$emit("select-updated", selectedSelect);
    },
    handleCheckboxChange(checkbox) {
      let item = {};
      item[checkbox.name] = checkbox.data;

      this.$emit("changeCheckbox", item);
    },

    formatedHour(input) {
      let data = input.data;
      if (data === "") {
      } else if (!/^[0-9:]+$/.test(data)) {
        data = "00:00";
      } else {
        data = data.replace(/[^\d:]/g, "");
        if (data.length >= 2 && data.indexOf(":") === -1) {
          data = data.substring(0, 2) + ":" + data.substring(2);
        }

        data = data.substring(0, 5);

        const [horas, minutos] = data.split(":").map(Number);

        if (!isNaN(minutos) && minutos > 59) {
          data = `${horas}:59`;
        }

        if (!isNaN(horas) && horas > 24) {
          data = "24:00";
        }
      }

      input.data = data;
    },
  },
};
</script>
<style scoped>
.slider-input {
  display: flex !important;
  justify-content: center !important;
  align-items: flex-end !important;
}

.slider-container {
  border: 1px solid #959595;
  height: 90px;
}

.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}

.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}

.small {
  font-size: x-large;
  align-content: center;
}

.drop-zone {
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 16px;
  transition: 0.2s;
}

.drop-zone:hover {
  border-color: #1976d2;
}

.drop-active {
  border-color: #4caf50;
  background-color: #f1f8e9;
}
</style>
